// Used to convert ComplexListFieldValue to list of PartialRecord

import { PartialRecord } from "../../../core/records/entities/partial-record.class";
import { setAny } from "../../../core/records/helpers/deep-get-set.helper";
import { FieldValue } from "../../entities/field-values/field-type-values.entity";

// Used so we can reuse existing ComplexField logic for displaying
export function FieldValuesToRecords(values:  FieldValue | FieldValue[], complexFieldDottedKey: string): PartialRecord[]  {
    if(!Array.isArray(values)) {
        return [CreatePartialRecordWithData(complexFieldDottedKey, values)];
    }

    return values.map(value=> CreatePartialRecordWithData(complexFieldDottedKey, value));
}

function CreatePartialRecordWithData(dottedKey: string, value: FieldValue): PartialRecord {
    const metadataPath: string[] = dottedKey.split('.');

    const metadata: any  = {};

    setAny(metadata, value, ...metadataPath);
    
    return new PartialRecord(metadata);
}